export const load = async () => {
	window.servicesManager = await import('@wix/services-manager' /* webpackChunkName: "servicesManager" */)
}
